/* eslint-disable import/first */
import "./publicPath";
import "isomorphic-fetch";
import "formdata-polyfill";
import "core-js/es/number";
import "core-js/es/weak-map";
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import { createStore } from "./store";

import ReactGA from "react-ga";

import "./sidebar.less";

import Root from "./containers/root";


ReactGA.initialize("UA-44063675-39", {
  debug: process.env.NODE_ENV === "development",
  testMode: process.env.NODE_ENV === "test"
});

const root = document.getElementById("react-root");

const store = createStore({});

render(
  <Provider store={store}>
    <Root />
  </Provider>,
  root
);
